import React from "react";
import { useTranslation } from "../../context/TranslationContext";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY_CONTACT } from "../../config/constants";
import Section from "../ui/Section";
import Button from "../ui/Button";

const Contact: React.FC = () => {
  const { t } = useTranslation();

  const contactInfo = [
    {
      icon: <Phone className="w-5 h-5" />,
      title: t("contact.phone.title"),
      value: COMPANY_CONTACT.phone,
      link: `tel:${COMPANY_CONTACT.phone}`,
    },
    {
      icon: <Mail className="w-5 h-5" />,
      title: t("contact.email.title"),
      value: COMPANY_CONTACT.email,
      link: `mailto:${COMPANY_CONTACT.email}`,
    },
    {
      icon: <MapPin className="w-5 h-5" />,
      title: t("contact.address.title"),
      value: COMPANY_CONTACT.address,
      link: `https://maps.google.com/?q=${encodeURIComponent(
        COMPANY_CONTACT.address
      )}`,
    },
  ];

  return (
    <Section id="contact" background="dark">
      <div className="text-center mb-12">
        <h2 className="headline mb-6">{t("contact.title")}</h2>
        <p className="section-description mx-auto">
          {t("contact.description")}
        </p>
      </div>

      <div className="flex gap-3 items-center justify-center flex-wrap flex-col md:flex-row">
        {contactInfo.map((info, index) => (
          <a
            key={index}
            href={info.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group w-full md:w-fit"
          >
            <div className="bg-cloud p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 text-center overflow-hidden">
              <div className="flex items-center text-neutral gap-2">
                <div className="">{info.icon}</div>
                <h3 className="text-md font-medium">{info.title}</h3>
              </div>
              <p className="text-neutral w-fit text-lg font-bold group-hover:text-primary transition-colors duration-200 truncate">
                {info.value}
              </p>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-12 text-center">
        <a
          href={`mailto:${COMPANY_CONTACT.email}`}
          target="_blank"
          rel="noopener noreferrer"
          className="group"
        >
          <Button variant="secondary" size="lg">
            Open Email
          </Button>
        </a>
      </div>
    </Section>
  );
};

export default Contact;
